package com.iptvplayer.shared.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Channel(
    val id: String,
    val sourceId: String,
    val name: String,
    val streamUrl: String,
    val logoUrl: String? = null,
    val group: String? = null,
    val streamType: StreamType = StreamType.HLS
)

@Serializable
enum class StreamType {
    HLS,
    MPEGTS,
    DASH,
    DIRECT
}
